export const EQUITY_MARKET_SEGMENTS = {
	NSE_EQ: 'NSE_EQ',
	BSE_EQ: 'BSE_EQ',
	NSE_FO: 'NSE_FO',
	NSE_DERIVATIVES: 'NSE_DERIVATIVES',
	NSE_CUR: 'NSE_CUR',
	NSECDS: 'NSECDS',
	NSE_CURRENCY: 'NSE_CURRENCY',
};

export const MARKET_SEGMENT_LABELS = {
	NSE: 'NSE',
	BSE: 'BSE',
	NSECDS: 'NSECDS',
};

export const MARKET_SEGEMENT_MAPPER = {
	1: EQUITY_MARKET_SEGMENTS.NSE_EQ,
	3: EQUITY_MARKET_SEGMENTS.BSE_EQ,
	2: EQUITY_MARKET_SEGMENTS.NSE_FO,
	8: EQUITY_MARKET_SEGMENTS.BSE_EQ,
	13: EQUITY_MARKET_SEGMENTS.NSE_CUR,
	2048: EQUITY_MARKET_SEGMENTS.NSE_CUR,
};

export const SEGMENT_ID_MAPPER = {
	[EQUITY_MARKET_SEGMENTS.BSE_EQ]: 3,
	[EQUITY_MARKET_SEGMENTS.NSE_EQ]: 1,
	[EQUITY_MARKET_SEGMENTS.NSE_DERIVATIVES]: 2,
	[EQUITY_MARKET_SEGMENTS.NSE_FO]: 2,
	[EQUITY_MARKET_SEGMENTS.NSE_CUR]: 13,
	[EQUITY_MARKET_SEGMENTS.NSECDS]: 13,
	[EQUITY_MARKET_SEGMENTS.NSE_CURRENCY]: 13,
};

export const EXCHANGE_SEGEMENT_MAPPER = {
	NSE: EQUITY_MARKET_SEGMENTS.NSE_EQ,
	BSE: EQUITY_MARKET_SEGMENTS.BSE_EQ,
};

export const API_SEGMENT_ID_MAPPER = {
	[EQUITY_MARKET_SEGMENTS.BSE_EQ]: 8,
	[EQUITY_MARKET_SEGMENTS.NSE_EQ]: 1,
	[EQUITY_MARKET_SEGMENTS.NSE_DERIVATIVES]: 2,
	[EQUITY_MARKET_SEGMENTS.NSE_FO]: 2,
	[EQUITY_MARKET_SEGMENTS.NSE_CUR]: 2048,
};

export const API_SEGMENT_LABEL_MAPPER = {
	8: EQUITY_MARKET_SEGMENTS.BSE_EQ,
	1: EQUITY_MARKET_SEGMENTS.NSE_EQ,
	2: EQUITY_MARKET_SEGMENTS.NSE_FO,
	2048: EQUITY_MARKET_SEGMENTS.NSE_CUR,
};

export const API_EXCHANGE_LABEL_MAPPER = {
	1: MARKET_SEGMENT_LABELS.NSE,
	2: MARKET_SEGMENT_LABELS.NSE,
	2048: MARKET_SEGMENT_LABELS.NSECDS,
};

export const API_TO_MARKET_SEGMENT_MAPPER = {
	1: 1, // NSE
	3: 3, // BSE
	2: 2, // NSE FO
	8: 3, // BSE
	13: 13, // Currency
	2048: 13, // Currency
};

export const MARKET_TO_API_SEGMENT_MAPPER = {
	1: 1, // NSE
	2: 2, // NSE FO
	3: 8, // BSE
	8: 8, // BSE
	13: 2048, // Currency
	2048: 2048, // Currency
};

export const EXCHANGE_MAPPER = {
	[EQUITY_MARKET_SEGMENTS.BSE_EQ]: MARKET_SEGMENT_LABELS.BSE,
	[EQUITY_MARKET_SEGMENTS.NSE_EQ]: MARKET_SEGMENT_LABELS.NSE,
};

export const OPTION_TYPES = {
	CE: 'CE',
	PE: 'PE',
};

export const EXCHANGE_LABEL_MAPPER = {
	[EQUITY_MARKET_SEGMENTS.BSE_EQ]: 'BSE',
	[EQUITY_MARKET_SEGMENTS.NSE_EQ]: 'NSE',
	[EQUITY_MARKET_SEGMENTS.NSE_FO]: 'NSE',
	[EQUITY_MARKET_SEGMENTS.NSE_CUR]: 'NSE',
};

export const SCRIP_INSTRUMENTS = {
	EQUITY: 'EQUITIES',
	FUTURES: 'FUTSTK',
	OPTIONS: 'OPTSTK',
	OPTION_INDEX: 'OPTIDX',
	FUTURES_INDEX: 'FUTIDX',
	FUTURES_CURRENCY: 'FUTCUR',
	OPTIONS_CURRENCY: 'OPTCUR',
	INDICES: 'INDICES',
};

export const TRANSACTION_TYPES = {
	BUY: 'BUY',
	SELL: 'SELL',
	BUY_MORE: 'BUY MORE',
	B: 'BUY',
	S: 'SELL',
};

export const TRANSACTION_TYPE_VALUE = {
	BUY: 1,
	SELL: 2,
};

export const FREQUENCY_LIST = [
	{
		title: 'Weekly',
		value: 'WEEKLY',
	},
	{
		title: 'Monthly',
		value: 'MONTHLY',
	},
	{
		title: 'Daily',
		value: 'DAILY',
	},
];

export const WEEK_LIST = [
	{
		title: 'MONDAY',
		value: 'MONDAY',
	},
	{
		title: 'TUESDAY',
		value: 'TUESDAY',
	},
	{
		title: 'WEDNESDAY',
		value: 'WEDNESDAY',
	},
	{
		title: 'THURSDAY',
		value: 'THURSDAY',
	},
	{
		title: 'FRIDAY',
		value: 'FRIDAY',
	},
];

export const PRODUCT_TYPES = {
	DELIVERY: 'delivery',
	INTRADAY: 'intraday',
	SIP: 'sip',
	MTF: 'mtf',
	DELIVERY_PLUS: 'deliveryplus',
	CARRYFORWARD: 'carryforward',
	MULTILEG: 'multileg',
	BTST: 'btst',
};

export const EVENT_PRODUCT_TYPES = {
	DELIVERY: 'delivery',
	INTRADAY: 'intraday',
	SIP: 'sip order',
	MTF: 'mtf',
	CARRYFORWARD: 'carryforward',
	BTST: 'delivery plus',
};

export const ORDER_TYPE = {
	MARKET: 'RL-MKT',
	LIMIT: 'RL',
	STOPLOSS_MARKET: 'SL-MKT',
	STOPLOSS_LIMIT: 'SL',
};

export const PRODUCT_TYPE_MARGIN_MAPPER = {
	DELIVERY: 'D',
	INTRADAY: 'M',
	SIP: 'D',
	MTF: 'MF',
	CARRYFORWARD: 'D',
	MULTILEG: 'D',
	BTST: 'PT',
};

export const validityMapper = {
	day: 'DAY',
	ioc: 'IOC',
	gtd: 'GTD',
};

export const GTD_ALLOWED_PRODUCT = ['BTST', 'DELIVERY', 'MTF'];

export const TRANSACTION_ESTIMATES = {
	overView: {
		title: 'Transaction overview',
		dataAid: 'transactionOverview',
		charges: {
			quantity: {
				text: 'Quantity',
				dataAid: 'Quantity',
				value: '1',
			},
			price: {
				text: 'Buy price (Market)',
				dataAid: 'BuyPrice',
				value: '₹697.80',
			},
			tradePrice: {
				text: 'Trade value',
				dataAid: 'TradeValue',
				value: '₹697.80',
			},
			orderType: {
				text: 'Order type',
				dataAid: 'OrderType',
				value: 'Buy',
			},
			exchange: {
				text: 'Segment/Exchange',
				dataAid: 'Exchange',
				value: 'NSE',
			},
		},
	},
	estimates: {
		title: 'Transaction estimates*',
		dataAid: 'transactionEstimates',
		charges: [
			{
				text: 'Exchange turnover',
				dataAid: 'ExchangeTurnover',
				value: '₹697.80',
			},
			{
				text: 'Brokerage (Buy)',
				dataAid: 'Brokerage',
				value: '₹2.27',
			},
			{
				text: 'Exchange charges',
				dataAid: 'ExchangeCharges',
				value: '₹2.27',
			},
			{
				text: 'Securities Transaction charges (STT)',
				dataAid: 'Stt',
				value: '₹2.27',
			},
			{
				text: 'GST (on brokerage & exhange charges)',
				dataAid: 'Gst',
				value: '₹2.27',
			},
			{
				text: 'SEBI Charges',
				dataAid: 'SebiCharges',
				value: '₹2.27',
			},
			{
				text: 'Clearing charges',
				dataAid: 'ClearingCharges',
				value: '₹2.27',
			},
			{
				text: 'Stamp duty',
				dataAid: 'StampDuty',
				value: '₹2.27',
			},
			{
				text: 'DP charges**',
				dataAid: 'DpCharges',
				value: '₹2.27',
			},
			{
				text: 'Total tax & charge (on buy)',
				dataAid: 'TotalTax',
				value: '₹2.27',
			},
			{
				text: 'Estimated tax & charges (on sell)',
				dataAid: 'EstimatedTax',
				value: '₹2.27',
			},
			{
				text: 'Breakeven price (No profit, no loss)',
				dataAid: 'BreakevenPrice',
				value: '₹2.27',
			},
		],
	},
	note: {
		text: `*Information in Transaction Estimator is approximate, not actual. Refer to contract note emailed for exact prices, fees & charges for trades executed. ${'\n'}**DP charges is inclusive of GST.`,
		dataAid: 'info',
	},
};

export const ORDER_TAB_LIST = [
	{ label: 'Delivery', name: 'Delivery', value: 'DELIVERY' },
	{ label: 'Intraday', name: 'Intraday', value: 'INTRADAY' },
	{ label: 'SIP', name: 'SIP', value: 'SIP' },
	{ label: 'Delivery plus', name: 'Delivery plus', value: 'BTST' },
	{ label: 'MTF', name: 'MTF', value: 'MTF' },
	{ label: 'Carryforward', name: 'Carryforward', value: 'CARRYFORWARD' },
	{ label: 'Multileg', name: 'Multileg', value: 'MULTI_LEG' },
];

export const EDIS_PRODUCTS = ['DELIVERY', 'BTST', 'MTF'];

export const AMO_NOT_APPLICABLE_ORDERS = [
	ORDER_TYPE.MARKET,
	ORDER_TYPE.STOPLOSS_MARKET,
];
export const AMO_NOT_APPLICABLE_PRODUCTS = [
	PRODUCT_TYPES.BTST,
	PRODUCT_TYPES.MTF,
];

export const EDIS_MAPPER = {
	quantiyError: {
		title: 'Entered Qty is greater than Original Qty',
		ctaText: 'OKAY',
	},
};

export const EXCHANGE_OPTIONS = [
	{ value: 'nse', title: 'NSE' },
	{ value: 'bse', title: 'BSE' },
];

export const PRODUCT_TYPE_ID = {
	DELIVERY: 'D',
	INTRADAY: 'M',
	SIP: 'D',
};

// WAVE PORTFOLIO

export const POSITION_FILTER_OPTIONS = [
	{ title: 'All', value: 'all' },
	{ title: 'Open', value: 'open' },
	{ title: 'Close', value: 'closed' },
];

export const SEGMENT_FILTER_OPTIONS = [
	{ title: 'All', value: 'all' },
	{ title: 'EQ. combined', value: 'eqCombined' },
];

export const POSITIONS_FILTER_INITIAL_STATE = {
	position: {},
	segment: {},
};

export const TRADE_SOCKET_CONSTANTS = {
	LOGIN_REQUEST: 'loginAPI',
};

export const INSTRUMENT_CATEGORIES = {
	equity: ['EQUITIES'],
	futures: ['FUTSTK', 'FUTIDX', 'FUTCUR'],
	options: ['OPTSTK', 'OPTIDX', 'OPTCUR'],
};

export const decimalLocator = 100;

export const ORDER_MODE = {
	MODIFY: 'M',
	NEW: 'N',
};

export const MARKET_FLAG_MAPPER = {
	MARKET_FLAG: 1,
	LIMIT_FLAG: 0,
};

export const LEG_INDICATOR_MAPPER = {
	NORMAL: 1,
	TWO_LEG: 5,
	THREE_LEG: 6,
	SPREAD: 4,
};

export const OPTION_CHAIN_INSTRUMENTS_MAPPER = {
	[SCRIP_INSTRUMENTS.EQUITY]: 'OPTSTK',
	[SCRIP_INSTRUMENTS.FUTURES]: 'OPTSTK',
	[SCRIP_INSTRUMENTS.OPTIONS]: 'OPTSTK',
	[SCRIP_INSTRUMENTS.OPTION_INDEX]: 'OPTIDX',
	[SCRIP_INSTRUMENTS.FUTURES_INDEX]: 'OPTIDX',
	[SCRIP_INSTRUMENTS.FUTURES_CURRENCY]: 'OPTCUR',
	[SCRIP_INSTRUMENTS.OPTIONS_CURRENCY]: 'OPTCUR',
};

export const OPTION_CHAIN_SEGMENT_ID_MAPPER = {
	[EQUITY_MARKET_SEGMENTS.NSE_EQ]: 2,
	[EQUITY_MARKET_SEGMENTS.NSE_DERIVATIVES]: 2,
	[EQUITY_MARKET_SEGMENTS.NSE_FO]: 2,
	[EQUITY_MARKET_SEGMENTS.NSE_CUR]: 2048,
};

export const DISPLAY_FRIENDLY_ORDER_TYPE = {
	MARKET: 'Market',
	LIMIT: 'Limit',
	'SL-M': 'SL-M',
	SL: 'SL',
};

export const EQUITY_API_SEGMENTS = [API_SEGMENT_ID_MAPPER.NSE_EQ, API_SEGMENT_ID_MAPPER.BSE_EQ];
export const EQUITY_SEGMENT_IDS = [SEGMENT_ID_MAPPER.NSE_EQ, SEGMENT_ID_MAPPER.BSE_EQ];
export const EQUITY_SEGMENTS = [EQUITY_MARKET_SEGMENTS.NSE_EQ, EQUITY_MARKET_SEGMENTS.BSE_EQ];

